export default __webpack_public_path__ + "static/media/more.b71a2e5f.svg";